import { useUserManagementHooks } from '@/manager/manager/agent-dashboard-user-management-manager';
import { SearchForm } from './search-form';
import { TableList } from './table-list';

/** 用户管理 */
export const UserManagement = () => {

  const {
    loading,
    agentUsersList,
    searchFormData,

    search,
    changeSearchForm,
    resetAndSearch,
    changePage,
  } = useUserManagementHooks.useAgentUserListData();

  return (
    <div className='w-full h-full flex flex-col overflow-hidden gap-5'>
      {/* 搜索栏 */}
      <SearchForm
        search={search}
        searchFormData={searchFormData}
        changeSearchForm={changeSearchForm}
        resetAndSearch={resetAndSearch}
      />
      {/* 用户列表 */}
      <TableList
        users={agentUsersList}
        loading={loading}
        total={searchFormData.total}
        page={searchFormData.page}
        pageSize={searchFormData.pageSize}
        changePage={changePage}
        search={search}
      />
    </div>
  )
}

